import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=25b84480&"
import script from "./GatewayDetail.vue?vue&type=script&lang=js&"
export * from "./GatewayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports